var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowExternal = function SvgArrowExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#AAA",
    clipPath: "url(#clip0_9349_189326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.947 22.957c4.459.31 8.995-.907 12.758-3.253 3.698-2.306 6.643-5.687 8.545-9.547 1.082-2.197 1.859-4.533 2.256-6.944.08-.477-.126-1.024-.66-1.143-.457-.102-1.08.136-1.166.649a24.2 24.2 0 0 1-1.48 5.215c-.024.061-.168.398-.08.193q-.074.173-.151.344a24 24 0 0 1-2.967 4.909c.019-.026.12-.149.01-.013q-.083.1-.164.2a22 22 0 0 1-2.065 2.205 21 21 0 0 1-1.476 1.252l-.125.097a21.408 21.408 0 0 1-4.21 2.435l-.216.093c-.165.07-.02.009.01-.004q-.216.088-.436.173-.746.284-1.508.513a21 21 0 0 1-2.602.595q-.228.035-.459.068c-.18.026-.009.002.023-.003q-.132.02-.267.031a19.6 19.6 0 0 1-3.572.075c-.494-.036-.97.451-.947.929.025.533.417.892.947.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.977 12.332q-1.16-5.827-2.32-11.655c-.135-.678-1.124-.905-1.585-.41l-6.656 7.162-1.88 2.022c-.333.36-.388.965 0 1.314.364.327.984.383 1.34 0q3.329-3.58 6.656-7.163l1.88-2.022-1.584-.41q1.16 5.827 2.32 11.655c.096.477.706.795 1.166.648.52-.165.764-.63.661-1.143z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9349_189326"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 0h27v23H7z"
  })))));
};
export default SvgArrowExternal;